import { UrlPrefixEnum, UrlTargetEnum } from '../../types/cmsEnums';
import { VerticalType } from '../../types/cmsTypes';

export { UrlTargetEnum } from '../../types/cmsEnums';

export enum NavigationItemTypeEnum {
  ExternalLink = 'external-link',
  Page = 'page',
  Article = 'article',
}

// Navigation types

export type NavigationPageRef = {
  slug: string;
  section?: VerticalType;
  urlPrefix?: UrlPrefixEnum;
};

export type NavigationArticleRef = {
  slug: string;
  section?: VerticalType;
  urlPrefix?: UrlPrefixEnum;
};

export type NavigationItemLevel1 = {
  label?: string;
  type?: NavigationItemTypeEnum;
  url?: string;
  url_target?: UrlTargetEnum;
  page?: NavigationPageRef;
  article?: NavigationArticleRef;
  sublinks?: Array<NavigationItemLevel2>;
};

export type NavigationItemLevel2 = {
  label?: string;
  type?: NavigationItemTypeEnum;
  url?: string;
  url_target?: UrlTargetEnum;
  page?: NavigationPageRef;
  article?: NavigationArticleRef;
  sublinks?: Array<NavigationItemLevel3>;
};

export type NavigationItemLevel3 = {
  label?: string;
  type?: NavigationItemTypeEnum;
  url?: string;
  url_target?: UrlTargetEnum;
  page?: NavigationPageRef;
  article?: NavigationArticleRef;
};

export type CmsNavigation = {
  name: string;
  items?: Array<NavigationItemLevel1>;
};
